import { useEffect, useRef } from 'react';

import useTimeout from './useTimeout';

/**
 * This hook should be implemented in all result rounds, where it is important that
 * the round is marked as played either after a timeout
 * or when the component is unmounted
 */

const DEFAULT_WAS_PLAYED_TIMEOUT_MARK = 1000 * 7;

function useAutoMarkAsPlayedResultRound(callback?: () => void) {
  const savedCallback = useRef(callback);

  // Remember the latest callback if it changes.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useTimeout(() => {
    // After 7 seconds. Mark the round as played
    savedCallback.current && savedCallback.current();
  }, DEFAULT_WAS_PLAYED_TIMEOUT_MARK);

  useEffect(() => {
    // When onmounting the component. Call the latest version of the callback
    return () => {
      savedCallback.current && savedCallback.current();
    };
  }, []);

  return null;
}

export default useAutoMarkAsPlayedResultRound;
